module.exports = __webpack_public_path__ + "static/media/stay-at-home.0840b63b.png";